module.exports = __webpack_public_path__ + "static/media/technology-2818664_1280.bfbbc81d.jpg";